import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import MasterclassForm from "./MasterclassForm";

/**
 * The bottom-of-page reservation section. The form itself lives in
 * MasterclassForm and is also rendered up in the hero. The ViewContent
 * observer is NOT installed here — the hero instance handles that.
 */
export default function MasterclassSection() {
  return (
    <section
      id="reservar"
      className="section-light relative py-24 md:py-40 overflow-hidden"
      data-testid="masterclass-section"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 60% 40% at 90% 10%, rgba(199,170,120,0.14), transparent 55%), radial-gradient(ellipse 50% 40% at 5% 90%, rgba(11,14,19,0.03), transparent 60%)",
          }}
        />
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6"
          >
            <p className="overline mb-6">◇ Únete a la lista de espera</p>
            <h2 className="font-serif font-normal text-4xl sm:text-5xl lg:text-6xl text-[#0B0E13] leading-[1.05] tracking-[-0.01em]">
              Tu segundo acto
              <br />
              <span className="italic text-[#6E7580]">empieza aquí.</span>
            </h2>
            <div className="gold-divider mt-8" />

            <div className="mt-10 space-y-5">
              <div className="inline-flex items-center gap-3 px-4 py-2 border border-[#C7AA78]/60 bg-[#C7AA78]/8 rounded-full">
                <span className="h-2 w-2 rounded-full bg-[#C7AA78] animate-pulse shrink-0" />
                <span className="text-[#8E7A55] text-[11px] font-medium tracking-[0.22em] uppercase leading-tight">
                  Próxima fecha muy pronto
                </span>
              </div>

              <p className="text-[#2A303A] text-lg leading-[1.65] max-w-md font-light font-sans">
                Una experiencia gratuita con Santi Lorenzo para comprender qué personaje sigue
                dirigiendo tu vida y qué sucede cuando empiezas a elegir desde quien eres hoy.
                Déjame tu WhatsApp y te aviso en cuanto anuncie la fecha.
              </p>

              <div className="pt-4 space-y-3">
                {[
                  "Método SIRCS aplicado en directo",
                  "Cómo se forma un patrón — y por qué se sostiene",
                  "Espacio de preguntas con Santi al final",
                ].map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <Check className="text-[#C7AA78] mt-1 shrink-0" size={16} strokeWidth={2.5} />
                    <p className="text-[#2A303A] text-base leading-snug font-sans font-light">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-6"
          >
            <MasterclassForm variant="section" observeViewContent={false} />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
